<div class="dialog dialog-medium dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">No active quote found</h4>
    <div class="dialog-inner">To start a new quote, please return to the homepage.  You will need a token provided by your employer to register.  When prompted respond “No” to continuing a previous quote.</div>

    <div class="dialog-inner-buttons">
        <button class="button-mgis" (click)="close()" class="chat-button chat-button-define" mat-flat-button>Go to token registration</button>
    </div>